import React, { useRef, useState } from 'react';
import { CheckCircle2, Play } from 'lucide-react';
export function TomosAndBonos() {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const handlePlay = () => {
    if (videoRef.current) {
      videoRef.current.play();
      setIsPlaying(true);
    }
  };
  const bonos = [{
    tramo: 'TRAMO 1 · Educación Inicial',
    icon: '📘',
    items: ['Juego simbólico y las 8 áreas del EBI', 'Mensajes para familias listos', 'Actividades para el día difícil']
  }, {
    tramo: 'TRAMO 2 · 1° y 2° año',
    icon: '📗',
    items: ['Conciencia fonológica con rúbricas listas', 'Cuando el grupo no puede con la lectura', '1° y 2° juntos · cómo organizarlo']
  }, {
    tramo: 'TRAMO 3 · 3° y 4° año',
    icon: '📙',
    items: ['Historia y Ciudadanía integradas', 'Evaluaciones express para las 8 áreas', 'El sistema para el domingo libre']
  }, {
    tramo: 'TRAMO 4 · 5° y 6° año',
    icon: '📓',
    items: ['Bioética y genética en 6° año', 'Proyecto ciudadano listo para el egreso', 'Feria de Ciencias sin estrés']
  }];
  return <>
      {/* SECCIÓN 4: LOS TOMOS */}
      <section className="py-16 px-4 bg-brand-lightBlue" data-id="element-219" data-mp="1xfwe9d9ey02s">
        <div className="max-w-5xl mx-auto" data-id="element-220" data-mp="2c5v9b75o8ve1">
          <h2 className="text-3xl md:text-4xl font-display font-bold text-brand-deep text-center mb-8" data-id="element-221" data-mp="2c8ziyk1wojc3">
            LO QUE RECIBÍS POR CADA TRAMO
          </h2>

          <div className="mb-12 flex justify-center" data-id="element-222" data-mp="1jjalggoen1f8">
            <div className="bg-white px-8 py-6 rounded-2xl shadow-sm border border-brand-sky max-w-2xl w-full" data-id="element-223" data-mp="1ej4ockzd8mpr">
              <div className="text-center mb-6" data-id="element-224" data-mp="1sinrezdbl7v7">
                <div className="text-5xl mb-4" data-id="element-225" data-mp="1sk8p2xuxl6xa">📚</div>
                <h3 className="text-2xl font-display font-bold text-brand-deep mb-2" data-id="element-226" data-mp="1ogstm4ullcm6">
                  8 Tomos Completos
                </h3>
                <p className="text-brand-text font-medium" data-id="element-227" data-mp="33w9hcmr07dhs">
                  Un librito específico para cada área del conocimiento, idéntico en estructura para todos los tramos.
                </p>
              </div>
              
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-y-3 gap-x-6 text-brand-text font-medium" data-id="element-228" data-mp="21kobrfxkvtdv">
                <div className="flex items-center gap-2" data-id="element-229" data-mp="26k10k680faj3"><span data-id="element-230" data-mp="26l2ld2etvbe0">📘</span> Matemáticas</div>
                <div className="flex items-center gap-2" data-id="element-231" data-mp="2alcq6bqvvvra"><span data-id="element-232" data-mp="2akbh2ctfhjc7">📗</span> Física y Química</div>
                <div className="flex items-center gap-2" data-id="element-233" data-mp="1dv2fp1ci5ua3"><span data-id="element-234" data-mp="1dw55t7203soy">🌿</span> Ciencias Biológicas</div>
                <div className="flex items-center gap-2" data-id="element-235" data-mp="1iu6nbnjs3jyb"><span data-id="element-236" data-mp="1iv8b8slw80xg">🌍</span> Ciencias de la Tierra y el Espacio</div>
                <div className="flex items-center gap-2" data-id="element-237" data-mp="1mw0k3kqus3t7"><span data-id="element-238" data-mp="1muyyimc7nyx8">📖</span> Lengua Española</div>
                <div className="flex items-center gap-2" data-id="element-239" data-mp="1rmh1ffxso9ku"><span data-id="element-240" data-mp="1rna9ck8hp54k">🏛️</span> Historia</div>
                <div className="flex items-center gap-2" data-id="element-241" data-mp="1robi2i219fj4"><span data-id="element-242" data-mp="v5dwg5i0k2ak">🗺️</span> Geografía</div>
                <div className="flex items-center gap-2" data-id="element-243" data-mp="v2hyih661dm4"><span data-id="element-244" data-mp="z5o7hwknxiwa">⚖️</span> Formación para la Ciudadanía</div>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-2xl p-6 md:p-8 shadow-lg border border-brand-sky max-w-3xl mx-auto mb-16" data-id="element-245" data-mp="rlltp90o76s9">
            <h3 className="text-xl font-display font-bold text-brand-deep mb-6 text-center" data-id="element-246" data-mp="mo3o9slv39p0">
              CADA TOMO INCLUYE:
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-247" data-mp="dn5qhs20nyev">
              {['Planificación anual lista para el director/a', '7 bloques con todas las fichas del año', 'Actividades listas para el aula', 'Evaluaciones + rúbricas + autoevaluación', 'Registro grupal y seguimiento individual', 'Conexión con la realidad uruguaya', 'Alineado al Programa EBI · ANEP 2026'].map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-248" data-mp="3v1144bcynidx" data-mpi={i}>
                  <CheckCircle2 className="w-5 h-5 text-brand-green flex-shrink-0 mt-0.5" data-id="element-249" data-mp="3r33h9f6nx8dp" />
                  <span className="text-brand-text font-medium" data-id="element-250" data-mp="3m1e15l4l24ir">{item}</span>
                </div>)}
            </div>
          </div>

          <div className="max-w-[320px] mx-auto" data-id="element-251" data-mp="3h5p9s52pvtxj">
            <h3 className="font-display font-bold text-brand-deep mb-6 text-center text-[32px]" data-id="element-252" data-mp="1l07tdsbfm30y">
              Mirá cómo es por dentro:
            </h3>
            <div className="relative mx-auto border-gray-800 dark:border-gray-800 bg-gray-800 border-[14px] rounded-[2.5rem] h-[600px] w-[300px] shadow-xl" data-id="element-253" data-mp="1q1ngrr130lmi">
              <div className="w-[148px] h-[18px] bg-gray-800 top-0 rounded-b-[1rem] left-1/2 -translate-x-1/2 absolute z-20" data-id="element-254" data-mp="1g8ptz8p24ai3"></div>
              <div className="h-[46px] w-[3px] bg-gray-800 absolute -left-[17px] top-[124px] rounded-l-lg" data-id="element-255" data-mp="12c2twx1t547y"></div>
              <div className="h-[46px] w-[3px] bg-gray-800 absolute -left-[17px] top-[178px] rounded-l-lg" data-id="element-256" data-mp="1698oar9t1wm4"></div>
              <div className="h-[64px] w-[3px] bg-gray-800 absolute -right-[17px] top-[142px] rounded-r-lg" data-id="element-257" data-mp="xavimo0ghmwj"></div>
              <div className="rounded-[2rem] overflow-hidden w-full h-full bg-white relative group" data-id="element-258" data-mp="2mpbl96880fnl">
                <video ref={videoRef} src="https://cdn.magicpatterns.com/uploads/dJY23cMfdmYBieVwDKRJ3P/0724 (1).mov" controls={isPlaying} preload="none" className="w-full h-full object-cover" poster="https://cdn.magicpatterns.com/uploads/53pSu5ZqyJEKnLdMyRrx7p/ChatGPT_Image_29_jun_2026,_12_05_51_a.m..png" onPlay={() => setIsPlaying(true)} onPause={() => setIsPlaying(false)} data-id="element-259" data-mp="2rpg1qw94padt">
                  Tu navegador no soporta la etiqueta de video.
                </video>
                
                {!isPlaying && <button onClick={handlePlay} className="absolute inset-0 flex items-center justify-center bg-black/20 hover:bg-black/30 transition-colors z-10" aria-label="Reproducir video" data-id="element-260" data-mp="18q8gkre28bju">
                    <div className="w-16 h-16 bg-brand-orange text-white rounded-full flex items-center justify-center shadow-lg transform transition-transform group-hover:scale-110" data-id="element-261" data-mp="3ajpkbjz2ks9b">
                      <Play className="w-8 h-8 ml-1 fill-current" data-id="element-262" data-mp="3v8gypxpohtof" />
                    </div>
                  </button>}
              </div>
            </div>
          </div>

        </div>
      </section>

      {/* SECCIÓN 5: BONOS */}
      <section className="py-16 px-4 bg-white" data-id="element-263" data-mp="d0rg7wq547xv">
        <div className="max-w-5xl mx-auto" data-id="element-264" data-mp="d2m1xd98k430">
          <div className="text-center mb-12" data-id="element-265" data-mp="i0du88dsls7q">
            <h2 className="text-3xl md:text-5xl font-display font-bold text-brand-deep mb-4" data-id="element-266" data-mp="hzmbhy5anoyv">
              + 6 Bonos Estratégicos por tramo
            </h2>
            <p className="text-xl text-brand-text font-medium" data-id="element-267" data-mp="qrxpgkj81jxy">
              Incluidos en todas las opciones, sin costo extra, a continuación 3 ejemplos de cada tramo.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12" data-id="element-268" data-mp="10r5c5ybuiqxq">
            {bonos.map((bono, i) => <div key={i} className="bg-brand-lightBlue rounded-2xl p-6 border border-brand-sky relative overflow-hidden" data-id="element-269" data-mp="15p6v8j99uq97" data-mpi={i}>
                <div className="absolute top-0 right-0 bg-brand-orange text-white text-xs font-bold px-3 py-1 rounded-bl-lg" data-id="element-270" data-mp="2q8skwjflk25p">
                  6 bonos incluidos
                </div>
                <h3 className="text-xl font-display font-bold text-brand-deep mb-4 flex items-center gap-2" data-id="element-271" data-mp="2g8rvqgv1qrtl">
                  <span className="text-2xl" data-id="element-272" data-mp="2bbjld2g53s2w">{bono.icon}</span> {bono.tramo}
                </h3>
                <ul className="space-y-3 mb-6" data-id="element-273" data-mp="38x778teyys06">
                  {bono.items.map((item, j) => <li key={j} className="flex items-start gap-2 text-brand-text font-medium" data-id="element-274" data-mp="33ym68rrw84ao" data-mpi={j}>
                      <span className="text-brand-orange" data-id="element-275" data-mp="2z85q2zwou4km">🎁</span> {item}
                    </li>)}
                </ul>
                <div className="flex items-center gap-3 pt-4 border-t border-brand-sky" data-id="element-276" data-mp="2ua49qmqncjcu">
                  <span className="text-brand-gray line-through font-bold" data-id="element-277" data-mp="3rp9pg979egcj">
                    $990
                  </span>
                  <span className="text-brand-green font-display font-bold text-xl" data-id="element-278" data-mp="3mx89ac6z05h8">
                    GRATIS
                  </span>
                </div>
              </div>)}
          </div>

          <div className="bg-brand-yellow text-brand-deep text-center p-6 rounded-2xl shadow-[0_8px_24px_rgba(250,204,21,0.3)] max-w-2xl mx-auto" data-id="element-279" data-mp="3026y0j8lb84y">
            <p className="text-xl md:text-2xl font-display font-bold mb-2" data-id="element-280" data-mp="2m7xoc352spw1">
              🎁 $990 en bonos por tramo — GRATIS
            </p>
            <p className="font-medium text-[#1E3A8A]" data-id="element-281" data-mp="3ezhanvwyyk29">
              Incluidos en todas las opciones. Siempre.
            </p>
          </div>
        </div>
      </section>

      {/* SECCIÓN 6: EL SEGUNDO ÁNGULO - EMPRENDIMIENTO */}
      <section className="py-20 px-4 bg-brand-deep text-white" data-id="element-282" data-mp="35006jixd8e8e">
        <div className="max-w-4xl mx-auto" data-id="element-283" data-mp="39yjqxewb9hyn">
          <div className="text-center mb-16" data-id="element-284" data-mp="3a1fq16jwacoo">
            <h2 className="text-4xl md:text-5xl font-display font-bold text-brand-orange mb-6" data-id="element-285" data-mp="1tktmu856ytp0">
              PERO ESPERÁ.
            </h2>
            <p className="text-xl md:text-2xl font-medium leading-relaxed max-w-2xl mx-auto" data-id="element-286" data-mp="1ylhemw18veka">
              Porque Aula de Éxitos no es solo para la maestra que quiere su año
              resuelto.
              <br data-id="element-287" data-mp="1m1anusfjypus" />
              <br data-id="element-288" data-mp="1m3wr4fveuj77" />
              Es también para la maestra que quiere que su año resuelto{' '}
              <span className="text-brand-orange font-bold text-[20px]" data-id="element-289" data-mp="1zyz6dtm5dkwo">
                le genere dinero $$$.
              </span>
            </p>
          </div>

          <h3 className="text-2xl font-bold text-center mb-10" data-id="element-290" data-mp="17dh3yvjfp16e">
            En Uruguay hay tres tipos de docentes que están leyendo esto:
          </h3>

          <div className="grid md:grid-cols-3 gap-6 mb-20" data-id="element-291" data-mp="1h27h93jxcbkp">
            <div className="bg-white/10 border border-white/20 p-6 rounded-2xl" data-id="element-292" data-mp="1h3scywhz60k5">
              <h4 className="text-xl font-bold text-brand-orange mb-4" data-id="element-293" data-mp="1caz9eby8sy9n">
                LA MAESTRA CON CARGO
              </h4>
              <p className="text-gray-300 text-sm mb-4" data-id="element-294" data-mp="ok3hletse32e">
                Amás tu trabajo pero odiás perder los domingos planificando.
                Querés tener el año resuelto · dar tus clases con confianza y
                recuperar tu tiempo personal.
              </p>
              <div className="pt-4 border-t border-white/10" data-id="element-295" data-mp="o2jdn6sjnrhc">
                <p className="font-bold text-sm" data-id="element-296" data-mp="j2ds88cvb17p">Lo que te da:</p>
                <p className="text-brand-sky text-sm" data-id="element-297" data-mp="j4rqeq2ugtjh">
                  Todo el año planificado en una tarde. Más tiempo para vivir ·
                  para tu familia · para lo que importa fuera del aula.
                </p>
              </div>
            </div>

            <div className="bg-white/10 border border-white/20 p-6 rounded-2xl" data-id="element-298" data-mp="59xnn34biv4o">
              <h4 className="text-xl font-bold text-brand-orange mb-4" data-id="element-299" data-mp="dh0oc8uumt6">
                LA MAESTRA QUE QUIERE UN EXTRA
              </h4>
              <p className="text-gray-300 text-sm mb-4" data-id="element-300" data-mp="3rgnji73kerau">
                Tenés cargo · pero el sueldo no alcanza. Querés dar clases
                particulares · pero la idea de preparar más material te
                paraliza.
              </p>
              <div className="pt-4 border-t border-white/10" data-id="element-301" data-mp="1y0sx500ncuvw">
                <p className="font-bold text-sm" data-id="element-302" data-mp="1y2ccmoehb1wm">Lo que te da:</p>
                <p className="text-brand-sky text-sm" data-id="element-303" data-mp="22xjbniwszif7">
                  400 actividades listas para usar en tus clases particulares.
                  Sin preparar nada extra. Con 4 horas de clases recuperás la
                  inversión.
                </p>
              </div>
            </div>

            <div className="bg-white/10 border border-white/20 p-6 rounded-2xl" data-id="element-304" data-mp="1fb34ojkcwl75">
              <h4 className="text-xl font-bold text-brand-orange mb-4" data-id="element-305" data-mp="1jc54b1i6qz9n">
                LA MAESTRA EMPRENDEDORA
              </h4>
              <p className="text-gray-300 text-sm mb-4" data-id="element-306" data-mp="1o8vljs5q80wn">
                No tenés cargo o elegiste la independencia. Querés que tu título
                sea la base de un negocio propio que genere ingresos reales.
              </p>
              <div className="pt-4 border-t border-white/10" data-id="element-307" data-mp="10kcchaeurk3i">
                <p className="font-bold text-sm" data-id="element-308" data-mp="10iswzm10td2s">Lo que te da:</p>
                <p className="text-brand-sky text-sm" data-id="element-309" data-mp="23uhrrxn5pm8g">
                  La infraestructura completa para montar tu consultorio
                  pedagógico. Sistema · actividades · evaluaciones y registros
                  para mostrar resultados medibles.
                </p>
              </div>
            </div>
          </div>

          <div className="bg-white text-brand-deep p-8 md:p-10 rounded-3xl shadow-xl" data-id="element-310" data-mp="28n1gnqrao3sk">
            <h3 className="md:text-3xl font-display font-bold mb-8 text-center text-[28px]" data-id="element-311" data-mp="1kx75ddmminaf">
              La matemática del emprendimiento con MEGAPACK AULA DE EXITO
              BUSINESS
            </h3>

            <div className="space-y-6" data-id="element-312" data-mp="1tyn5msjq590x">
              <div className="flex flex-col md:flex-row items-center justify-between p-4 bg-brand-lightBlue rounded-xl" data-id="element-313" data-mp="1oyin6wz9a482">
                <div className="font-bold text-lg" data-id="element-314" data-mp="35bpl1ka37sji">
                  INVERSIÓN EN MEGAPACK AULA DE EXITOS BUSINESS
                </div>
                <div className="text-2xl font-display font-bold text-brand-orange" data-id="element-315" data-mp="30d5zhkzeoiro">
                  $2.490 UYU
                </div>
              </div>

              <div className="grid md:grid-cols-2 gap-6" data-id="element-316" data-mp="3cw9zdgnrz519">
                <div className="border border-gray-200 p-5 rounded-xl" data-id="element-317" data-mp="3ctou0ho9q6yr">
                  <h4 className="font-bold text-brand-blue mb-2" data-id="element-318" data-mp="2yxtiwy04205x">
                    CON 4 HORAS DE CLASES PARTICULARES:
                  </h4>
                  <p className="text-sm text-brand-text mb-2" data-id="element-319" data-mp="3rl63x3qmhzx4">
                    4 horas × $700 UYU = $2.800 UYU
                  </p>
                  <p className="text-sm font-bold text-brand-green" data-id="element-320" data-mp="dlamz1fyl72">
                    Recuperaste la inversión completa. El material te dura toda
                    la vida.
                  </p>
                </div>

                <div className="border border-gray-200 p-5 rounded-xl" data-id="element-321" data-mp="3msd0cj6w4xmm">
                  <h4 className="font-bold text-brand-blue mb-2" data-id="element-322" data-mp="edcqz6ffkdo8">
                    CON 3 ALUMNOS MENSUALES:
                  </h4>
                  <p className="text-sm text-brand-text mb-2" data-id="element-323" data-mp="j779i6jaumlq">
                    3 alumnos × $2.800 UYU (paquete mensual)
                  </p>
                  <p className="text-sm font-bold text-brand-green" data-id="element-324" data-mp="2mmkjnd1yq54c">
                    = $8.400 UYU por mes
                  </p>
                </div>

                <div className="border border-gray-200 p-5 rounded-xl" data-id="element-325" data-mp="2hq3nbvkm0kg6">
                  <h4 className="font-bold text-brand-blue mb-2" data-id="element-326" data-mp="2cq7rwkpza1c8">
                    CON 8 ALUMNOS EN GRUPOS DE 4:
                  </h4>
                  <p className="text-sm text-brand-text mb-2" data-id="element-327" data-mp="3aehlqcfm1is9">
                    2 grupos × 4 niños × $450 × 4 sesiones
                  </p>
                  <p className="text-sm font-bold text-brand-green" data-id="element-328" data-mp="30ltr9oc3rqwp">
                    = $14.400 UYU por mes
                  </p>
                </div>

                <div className="border border-gray-200 p-5 rounded-xl" data-id="element-329" data-mp="2vlxv2b9nd3rp">
                  <h4 className="font-bold text-brand-blue mb-2" data-id="element-330" data-mp="3t4h64m0ia9pc">
                    CON EL PROGRAMA INTENSIVO DE VERANO:
                  </h4>
                  <p className="text-sm text-brand-text mb-2" data-id="element-331" data-mp="3vnuemovm2x32">
                    1 grupo de 5 niños × $3.500 × 3 semanas
                  </p>
                  <p className="text-sm font-bold text-brand-green" data-id="element-332" data-mp="4ht72qauulm6">
                    = $52.500 UYU en 3 semanas
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>;
}